<template>
   <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>SIGN IN</h2>
					</div>
					<div class="panel panel-widget forms-panel">
						<div class="forms">
							<div class="form-grids widget-shadow" data-example-id="basic-forms"> 
								<div class="form-title">
									<h4>USER SIGN IN </h4>
								</div>

								<div class="form-body">
									<form v-on:submit.prevent="handleSubmit()"> 
                                    <div class="form-group"> 
                                    <label for="exampleInputEmail1">Email address</label> 
                                    <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email" v-on:change="emailHandler($event)">
                                     </div> <div class="form-group">
                                      <label for="exampleInputPassword1">Password</label> 
                                      <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-on:change="passwordHandler($event)">
                                       </div> 
                                    
                                        
                                          <button type="submit" class="btn btn-default">Submit</button>
                                    </form> 
								</div>
							</div>
						</div>
					</div>
					
					
          
            
					
				</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'signIn',
  props: {
  
},
data()
{
    return{
        "email":null,
        "password":null,
        "tokenPresence": false,
        "image":"https://time-person-mofe.herokuapp.com/public/images/fe382ce5ff79e09bb7a2c55db2c6aa59.jpg"
   
    }
},
     mounted()
    {
        //check for token and redirect to dashboard
        let accessToken = localStorage.getItem("token");
       if(accessToken !== "noToken")
        {
         if(accessToken !== null)
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
       
       

        if(accessToken !== null)
        {
          if(accessToken !== "noToken")
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
        

        if((accessToken != "noToken") && (accessToken !== null) && (this.tokenPresence == true))
        {
            this.$router.push("/timeawards/userDashboard");
        }

    }
,
methods:
{
    passwordHandler: function(e)
    {
        let passwordValue = e.target.value;
        this.password = passwordValue;
    },
    emailHandler: function(e)
    {
        let emailValue = e.target.value;
        this.email = emailValue;
    },
    handleSubmit: async function ()
    {
       // e.preventDefault;
        if((this.email != null) && (this.password != null) && (this.email != "") && (this.password != ""))
        {
            //make axios call
            try{
                    let response  =  await axios.post("https://time-person-mofe.herokuapp.com/api/login",{
                        email: this.email,
                        password: this.password
                    });

                    let status = response.data.status;
                    let token = response.data.accessToken;
                  
                    if(status == "success"){
                  
                  localStorage.setItem("token",token);
                  this.$router.push("/timeawards/userDashboard");
                     }else{
                         alert('SignIn not successful');
                     } 
             
                    
            }
            catch(error){
                   alert(`SignIn not successful ${error}`);
            }
        
        }
        else
        {
            alert("Please fill form properly before submitting");
        }
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
